import { useIntl } from 'react-intl';

import { Button } from '../../../../design-system/components/form/button/Button';
import { Typography } from '../../../../design-system/components/typography/Typography';

import style from './SearchErrorState.module.css';

type Props = { onRetry: () => void };

export function SearchErrorState({ onRetry }: Props) {
    const { formatMessage } = useIntl();

    return (
        <div className={style.errorState} role="alert">
            <Typography as="p" scale="primary-xs-regular" className={style.errorMessage}>
                {formatMessage({ id: 'global.search.overlay.error.message' })}
            </Typography>
            <Button type="button" priority="secondary" onClick={onRetry}>
                {formatMessage({ id: 'global.search.overlay.error.retry' })}
            </Button>
        </div>
    );
}
